export interface FAQItem {
    key: string;
    question: string;
    answer: string | JSX.Element; // Allow both string and JSX
}

const faqs: FAQItem[] = [
    {
        key: "claimAsk",
        question: "How do I make a claim?",
        answer: "You submit a claim to your policy. All the other members of your policy get an opportunity to review, comment, and vote on the claim. If your claim is approved, the money is paid out to you.",
    },
    {
        key: "escrowAsk",
        question: "Who manages the money?",
        answer: "The money is managed by an elected member of your policy. This person is referred to as the Escrow Agent and is responsible for keeping track of premiums and paying the claims approved by the group.",
    },
    {
        key: "escrowLocationAsk",
        question: "Where do I send my premiums?",
        answer: "Use Venmo to send money to the escrow agent. You can use Open Insure to keep track of your payments, but please note that no actual money is exchanged on the platform.",
    },
    {
        key: "premiumAsk",
        question: "How much does it cost?",
        answer: "By cutting out the insurance company, our members find premiums to be 30-50% cheaper than traditional insurance. Premiums are computed based on multiple variables, all of which are controlled by your group in the policy settings.",
    },
    {
        key: "whoIsAParticipantAsk",
        question: "Who can join my policy?",
        answer: "We recommend you only allow people you already know and trust into your policy. Friends and family are a good place to start. You can invite them to join by sending them a link to your policy. In the future, if needed, you will be able to remove members from your policy.",
    },
    {
        key: "whatIsTheRefundPolicy",
        question: "What is the refund policy?",
        answer: (
            <>
                Please refer to our policy{" "}
                <a
                    href="https://openinsure.app/refund"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    here
                </a>
                .
            </>
        ),
    },
];

export default faqs;
